module.exports = __webpack_public_path__ + "static/img/case3.7d6357f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/case3.png
// module id = cVs2
// module chunks = 0